export default __webpack_public_path__ + "static/media/UepLogo.2432d50f.png";